import { Component, ErrorInfo, ReactNode } from 'react';
import { Button, Typography } from '@zeptonow/zui';
import { ErrorBoundary as HawkeyeErrorBoundary } from '@zeptonow/hawkeye';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    return (
      <HawkeyeErrorBoundary
        fallback={
          <div className="flex flex-col items-center justify-center h-[calc(100vh-4rem-4.5rem)] p-5">
            <Typography variant="h1">Something went wrong.</Typography>
            <div className="flex space-x-4 mt-4">
              <Button
                variant="outlined"
                className="!text-primary-700 border !border-primary-700"
                onClick={this.handleReload}
              >
                Reload Page
              </Button>
              <Button
                variant="outlined"
                className="!text-primary-700 border !border-primary-700"
                onClick={this.handleGoHome}
              >
                Go to Home
              </Button>
            </div>
          </div>
        }
      >
        {this.props.children}
      </HawkeyeErrorBoundary>
    );
  }
}

export default ErrorBoundary;
